export default {
  recaptcha: {
    publicKey: null,
  },
};
